import React from 'react'
import { useHistory } from 'react-router-dom'

const QuizNavigation = ({ dispatch, ...props }) => {
  const quiz = props.quiz
  const history = useHistory()

  const handleNext = (e) => {
    e.preventDefault()

    if (props.index == props?.questions.length - 1) {
      return
    }
    dispatch(props.onClick(props.index + 1))
    history.push(`${props.match.path}?index=${props.index + 1}`)
  }

  const handlePrev = (e) => {
    e.preventDefault()
    if (props.index == 0) {
      return
    }
    dispatch(props.onClick(props.index - 1))
    history.push(`${props.match.path}?index=${props.index - 1}`)
  }

  return (
    <div className='col px-0'>
      <div className='quiz-row-wrapper'>
        {(() => {
          const current =
            props.currentContentQuiz && props.currentContentQuiz.index > -1
              ? props.currentContentQuiz.index
              : 0
          var from = 0,
            to = 0,
            reduce = 0,
            len = quiz && quiz.questions && quiz.questions.length
          const range = window.innerWidth < 500 ? 4 : 4
          const currentRange = window.innerWidth < 500 ? 2 : 2

          if (len > 9) {
            from = current - currentRange >= 0 ? current - currentRange : 0
            reduce = len - current - 1

            if (reduce < 4) {
              from = from - (currentRange - reduce)
            }
          }
          return (
            <div>
              <span
                style={{ display: 'flex', justifyContent: 'space-between' }}
                className='question-title mb-1'
              >
                <p>
                  {`Question ${current + 1} of ${
                    props.currentContentQuiz &&
                    props.currentContentQuiz.questions
                      ? props.currentContentQuiz.questions.length
                      : ''
                  }`}
                </p>
                <div>
                  <span className='text-muted mr-3 '>
                    Submit quiz when ready
                  </span>
                  <button
                    onClick={() => dispatch(props.onSubmitContentQuiz())}
                    class='btn btn-info py-2 px-4'
                  >
                    Submit
                  </button>
                </div>
              </span>
              <nav>
                <ul class='pagination px-0 custom-pagination'>
                  <li class='page-item'>
                    <a //eslint-disable-line
                      class='page-link'
                      aria-label='Previous'
                      onClick={(e) => handlePrev(e)}
                    >
                      <span aria-hidden='true' className=''>
                        &laquo;
                      </span>
                      <span class='sr-only'>Previous</span>
                    </a>
                  </li>
                  {props.currentContentQuiz &&
                    props.currentContentQuiz.questions &&
                    props.currentContentQuiz.questions.length &&
                    props.currentContentQuiz.questions.map((item, index) => {
                      if (len < 10 || (index >= from && to <= range)) {
                        to++

                        const cn =
                          current === index
                            ? 'bg-success text-white'
                            : item.type === 4 ||
                              (item.options &&
                                item.options.filter((item) => item.selected)
                                  .length)
                            ? 'bg-info text-white'
                            : ''

                        return (
                          <li className='page-item'>
                            <a //eslint-disable-line
                              className={'page-link ' + cn}
                              key={index}
                              onClick={() => {
                                dispatch(props.onClick(index))
                                history.push(
                                  `${props.match.path}?index=${index}`
                                )
                              }}
                            >
                              {index + 1}
                            </a>
                          </li>
                        )
                      }
                    })}
                  <li class='page-item'>
                    <a //eslint-disable-line
                      class='page-link'
                      onClick={(e) => handleNext(e)}
                      aria-label='Next'
                    >
                      <span aria-hidden='true' className='pb-0'>
                        &raquo;
                      </span>
                      <span class='sr-only'>Next</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          )
        })()}
      </div>
    </div>
  )
}

export default QuizNavigation
